import get from "lodash/get";
import React from "react";
import { connect } from "react-redux";
import activities from "./activities";
import { displayOpen, displayClose } from "src/pods/realtime";
import CastControl from "src/pods/realtime/components/CastControl";
import logEvent from "src/utils/logEvent";
import { navigate } from "src/utils/reactRouterNavigate";

type ConundrumRemoteRendererProps = {
  displayOpen: (path: string) => void;
  displayClose: VoidFunction;
  params: {
    mountPoint: string;
    classId: string;
    conundrumName: string;
    stepName: string;
  };
};

export default connect(() => ({}), {
  displayOpen,
  displayClose,
})(
  // eslint-disable-next-line react-prefer-function-component/react-prefer-function-component
  class ConundrumRemoteRenderer extends React.Component<ConundrumRemoteRendererProps> {
    componentDidMount() {
      const { conundrumName, stepName } = this.props.params;
      const index = parseInt(stepName, 10);
      const Slide = this.getSlide("display", conundrumName, index);
      if (Slide) {
        this.showDisplaySlide();
      }
      logEvent({
        eventName: `conundrums.${conundrumName}.${stepName}`,
      });
    }

    componentWillUnmount() {
      this.props.displayClose();
    }

    render() {
      const {
        params: { conundrumName, stepName },
      } = this.props;
      const index = parseInt(stepName, 10);
      const Slide = this.getSlide("remote", conundrumName, index);
      if (!Slide) {
        return <div>{`Couldn't find slide for ${conundrumName} ${stepName} (remote)`}</div>;
      }

      const hasDisplay = Boolean(this.getSlide("display", conundrumName, index));
      const { classId, mountPoint } = this.props.params;

      return (
        <div>
          {hasDisplay && <CastControl onRequestStart={this.showDisplaySlide} />}
          <Slide
            goToLaunchpad={() => navigate(`/apps/remote/${mountPoint}/${classId}`)}
            goToTeacherTips={() => {
              /* this has been broken for a while now */
            }}
            next={(numSteps = 1) => {
              this.onIndexChange(index + numSteps);
            }}
            prev={(numSteps = 1) => {
              this.onIndexChange(index - numSteps);
            }}
          />
        </div>
      );
    }

    UNSAFE_componentWillReceiveProps(nextProps: ConundrumRemoteRendererProps) {
      // NOTE: listening on route changes (via prop changes) to know whether we've changed
      // slides. We must do this because slide changes can happen via browser history change.
      const params = this.props.params;
      const nextParams = nextProps.params;

      // notify display if slide has changed
      const PrevSlide = this.getSlide("display", params.conundrumName, parseInt(params.stepName, 10));
      const NextSlide = this.getSlide("display", nextParams.conundrumName, parseInt(nextParams.stepName, 10));
      if (NextSlide !== PrevSlide) {
        // change display to new slide or no slide
        if (NextSlide) {
          const { conundrumName, stepName } = nextParams;
          this.props.displayOpen(`/apps/display/conundrums/${conundrumName}/${stepName}`);
        } else {
          this.props.displayClose();
        }
      }

      // log event if slide has changed
      if (nextParams.conundrumName !== params.conundrumName || nextParams.stepName !== params.stepName) {
        logEvent({
          eventName: `conundrums.${nextParams.conundrumName}.${nextParams.stepName}`,
        });
      }
    }

    showDisplaySlide = () => {
      const { conundrumName, stepName } = this.props.params;
      this.props.displayOpen(`/apps/display/conundrums/${conundrumName}/${stepName}`);
    };

    getSlide(role: string, conundrumName: string, index: number) {
      const definition = activities[conundrumName];
      return get(definition, [index, role]);
    }

    onIndexChange(nextIndex: number) {
      const {
        params: { mountPoint, classId, conundrumName },
      } = this.props;

      if (nextIndex < 0) {
        navigate(`/apps/remote/${mountPoint}/${classId}/conundrums`);
        return;
      }
      if (!this.getSlide("remote", conundrumName, nextIndex)) {
        navigate(`/apps/remote/${mountPoint}/${classId}/conundrums/${conundrumName}/0`);
        return;
      }
      // change remote to new slide
      navigate(`/apps/remote/${mountPoint}/${classId}/conundrums/${conundrumName}/${nextIndex}`);
    }
  },
);
